module.exports = __webpack_public_path__ + "assets/img/box.79cdbd66.svg";